import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {Milestone} from './milestone'
import {buildItemPickersUrl} from '@github-ui/item-picker-base/api/urls'

export type CreateMilestoneRequest = {
  repositoryId: string
  title: string
}

type CreateMilestoneResponseData = {
  createMilestone: {
    milestone: Milestone
  }
}

export type CreateMilestoneResponse = GraphQLResponse<CreateMilestoneResponseData>

export async function apiCreateMilestone(request: CreateMilestoneRequest): Promise<CreateMilestoneResponse> {
  const pathname = buildItemPickersUrl('milestones')

  const init = {
    method: 'POST',
    body: request,
  }

  const response = await verifiedFetchJSON(pathname, init)
  return response.json() as Promise<CreateMilestoneResponse>
}
